export default {
  setLoading (state, payload) {
    state.loading = payload
  },
  setResources (state, payload) {
    state.resources = payload
  },
  setResource (state, payload) {
    state.resource = payload
  }
}
